import { Component, Inject, LOCALE_ID, ViewEncapsulation } from '@angular/core';
import { CldrIntlService, IntlService } from '@progress/kendo-angular-intl';
import { MessageService } from '@progress/kendo-angular-l10n';
import { NotificationsService } from './core/services/notifications.service';
import { TranslationsService } from './core/services/translations.service';

@Component({
  selector: 'app-root',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(
    private notifications: NotificationsService,
    @Inject(LOCALE_ID) private locale: string,
    private intl: IntlService,
    private messages: MessageService
  ) {
    console.log(this.locale);
    (<CldrIntlService>this.intl).localeId = this.locale;
    (<TranslationsService>this.messages).language = this.locale;
  }
}
